import type { TRuleWithTheme } from '@ackee/fela';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
});

export const link: TRuleWithTheme = ({ theme: { colors, transition } }) => ({
    lineHeight: 0,
    marginLeft: '1.65rem',

    fill: colors.blue,

    transition,
    transitionProperty: 'fill',

    ':hover': {
        fill: colors.fuchsia,
    },

    ':first-child': {
        marginLeft: 0,
    },
});
